import React from 'react';

import './itemDetail.scss';

export default class LearningPathItemDetail extends React.Component {

    handleTaskClicked(event){

        event.preventDefault();
        let redirectUrl = PlatformSDK.openProtectedData(event.currentTarget.href);
        if (redirectUrl)
            window.open(redirectUrl, '_blank', 'noopener,noreferrer');
        // Prevent the link to open if the protected data is a link
    }



    render() {
        const { data } = this.props;
        const fullSizeColumn = data.CollectionsFull.length <= 1;
        const collections = data.CollectionsFull.map(i => this.renderCollection(i, fullSizeColumn));
        return (
            <div className='item-detail'>
                <i className="close-btn" onClick={this.props.onClose} />
                <div className='container'>
                    <div className='path-detail-title'>{data.Title}</div>
                    <div className='row collections'>
                        {collections}
                    </div>
                </div>
            </div>
        );
    }

    renderCollection(data, fullSizeColumn) {
        const collectionClass = `${fullSizeColumn? "col-md-12":"col-md-6"}`;
        const taskes = data.TasksFull.map(i => this.renderTask(i));
        return (
            <div key={data.id} className={'col-12 collection-col ' + collectionClass}>
                <div className='collection'>
                    <div className='info'>
                        <span className='title'>{data.Title}</span>
                        <i className="fal fa-clock"></i>
                        <span className={"time"}>{Math.ceil(data.Duration/60) + " hours"}</span>
                        <div className={"description"}>{data.Description}</div>
                    </div>
                    <div className='tasks'>
                        {taskes}
                    </div>
                </div>
            </div>
        );
    }

    renderTask(data) {
        const className = 'task' + (data.completed ? ' completed' : '');
        return (
            <a key={data.id} className={className} href={data.URL} target='_blank' onClick={this.handleTaskClicked}  rel="noopener noreferrer">
                <div className='icon'></div>
                <div className='title-container'><span className={"title"} >{data.Title} </span>  <span className={'duration'} > {`(${data.Duration} min)`} </span></div>
                <div className='arrow'></div>
            </a>
        );
    }
}
